/* Banner de cookies MORAY.
   La UI es propia de Moray; Customer Privacy API es la unica fuente de verdad.
   El consentimiento solo se escribe despues de una accion del visitante. */
(function () {
  'use strict';

  if (window.__morayCookiesLoaded) return;
  window.__morayCookiesLoaded = true;

  var ROOT = '[data-cookies]';
  var privacyLoading = false;
  var privacyQueue = [];

  function flushPrivacy(cp) {
    var queue = privacyQueue.slice();
    privacyQueue = [];
    privacyLoading = false;
    queue.forEach(function (callback) { callback(cp || null); });
  }

  function withCustomerPrivacy(callback) {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      callback(window.Shopify.customerPrivacy);
      return;
    }

    privacyQueue.push(callback);
    if (privacyLoading) return;
    privacyLoading = true;

    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      flushPrivacy(null);
      return;
    }

    window.Shopify.loadFeatures([
      { name: 'consent-tracking-api', version: '0.1' }
    ], function (error) {
      flushPrivacy(error ? null : window.Shopify.customerPrivacy);
    });
  }

  function visitorConsent(cp) {
    try {
      var current = cp.currentVisitorConsent() || {};
      return {
        answered: ['yes', 'no'].indexOf(current.analytics) !== -1 ||
          ['yes', 'no'].indexOf(current.marketing) !== -1 ||
          ['yes', 'no'].indexOf(current.preferences) !== -1,
        analytics: current.analytics === 'yes',
        marketing: current.marketing === 'yes',
        preferences: current.preferences === 'yes'
      };
    } catch (error) {
      return { answered: false, analytics: false, marketing: false, preferences: false };
    }
  }

  function shouldShow(cp) {
    try {
      if (typeof cp.shouldShowBanner === 'function') return cp.shouldShowBanner() === true;
    } catch (error) {}
    return !visitorConsent(cp).answered;
  }

  function updateGoogleConsent(consent) {
    if (typeof window.gtag !== 'function') return;
    var marketing = consent.marketing ? 'granted' : 'denied';
    var analytics = consent.analytics ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
      ad_storage: marketing,
      ad_user_data: marketing,
      ad_personalization: marketing,
      personalization_storage: marketing,
      analytics_storage: analytics,
      functionality_storage: 'granted',
      security_storage: 'granted'
    });
    window.gtag('set', 'ads_data_redaction', marketing !== 'granted');
  }

  function init() {
    var root = document.querySelector(ROOT);
    if (!root || root.dataset.cookiesReady) return;
    root.dataset.cookiesReady = '1';

    var panel = root.querySelector('[data-cookies-prefs]');
    var analyticsInput = root.querySelector('[data-cookies-analytics]');
    var marketingInput = root.querySelector('[data-cookies-marketing]');
    var configureButton = root.querySelector('[data-cookies-action="prefs"]');
    var hideTimer = null;
    var saving = false;

    function setBusy(busy) {
      saving = busy;
      root.toggleAttribute('data-saving', busy);
      root.querySelectorAll('button').forEach(function (button) { button.disabled = busy; });
    }

    function syncControls(cp) {
      var consent = visitorConsent(cp);
      if (analyticsInput) analyticsInput.checked = consent.analytics;
      if (marketingInput) marketingInput.checked = consent.marketing;
      return consent;
    }

    function show(force) {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      setBusy(false);
      withCustomerPrivacy(function (cp) {
        if (cp) syncControls(cp);
        if (!force && cp && !shouldShow(cp)) return;
        root.hidden = false;
        setTimeout(function () {
          root.setAttribute('data-open', '');
          var first = root.querySelector('[data-cookies-action="accept"]');
          if (force && first) first.focus({ preventScroll: true });
        }, 16);
        document.body.classList.add('has-cookie-banner');
      });
    }

    function hide() {
      root.removeAttribute('data-open');
      document.body.classList.remove('has-cookie-banner');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        root.hidden = true;
        hideTimer = null;
      }, 260);
    }

    function save(consent) {
      if (saving) return;
      setBusy(true);
      withCustomerPrivacy(function (cp) {
        if (!cp || typeof cp.setTrackingConsent !== 'function') {
          setBusy(false);
          return;
        }

        var payload = {
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: !!consent.preferences
        };

        try {
          if (typeof cp.saleOfDataRegion === 'function' && cp.saleOfDataRegion()) {
            payload.sale_of_data = !!consent.marketing;
          }
          cp.setTrackingConsent(payload, function () {
            updateGoogleConsent(payload);
            setBusy(false);
            hide();
          });
        } catch (error) {
          setBusy(false);
        }
      });
    }

    root.addEventListener('click', function (event) {
      var target = event.target.closest('[data-cookies-action]');
      if (!target) return;
      var action = target.getAttribute('data-cookies-action');

      if (action === 'accept') {
        save({ analytics: true, marketing: true, preferences: true });
        return;
      }
      if (action === 'reject') {
        save({ analytics: false, marketing: false, preferences: false });
        return;
      }
      if (action === 'prefs') {
        var open = panel.hasAttribute('data-open');
        panel.hidden = open;
        panel.toggleAttribute('data-open', !open);
        target.setAttribute('aria-expanded', open ? 'false' : 'true');
        return;
      }
      if (action === 'save') {
        save({
          analytics: analyticsInput ? analyticsInput.checked : false,
          marketing: marketingInput ? marketingInput.checked : false,
          preferences: true
        });
      }
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-cookies-open]')) return;
      event.preventDefault();
      if (panel) {
        panel.hidden = true;
        panel.removeAttribute('data-open');
      }
      if (configureButton) configureButton.setAttribute('aria-expanded', 'false');
      show(true);
    });

    withCustomerPrivacy(function (cp) {
      if (!cp) return;
      var consent = syncControls(cp);
      if (consent.answered) updateGoogleConsent(consent);
      if (shouldShow(cp)) show(false);
    });
  }

  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = event && event.detail ? event.detail : {};
    updateGoogleConsent({
      analytics: detail.analyticsAllowed === true,
      marketing: detail.marketingAllowed === true
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
